// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3khfI","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__UtkbS"};